module.exports = __webpack_public_path__ + "img/example_1.75ca075f.png";